'use client'

import { CartProvider } from '@/lib/cart'
import type { PaymentMethodsSnapshot } from '@sifly/shared-types'
import { CommerceBarProvider } from '@/lib/commerceBar'
import { CartDrawer } from './CartDrawer'

export function CartShell({
  tenantId,
  freeShippingAch = false,
  flatAccessoryRate,
  hasPickupLocations = false,
  paymentMethods,
  checkoutMode = 'hosted',
  children,
}: {
  tenantId: string
  freeShippingAch?: boolean
  /** The store's accessory-only shipping rate (dollars); undefined = SiFly's default. */
  flatAccessoryRate?: number
  hasPickupLocations?: boolean
  /** Redacted storefront payment snapshot — see lib/storefrontPaymentMethods. */
  paymentMethods: PaymentMethodsSnapshot
  /** 'embedded' routes the drawer's checkout to /checkout; 'hosted' keeps Stripe's page. */
  checkoutMode?: 'hosted' | 'embedded'
  children: React.ReactNode
}) {
  return (
    <CartProvider tenantId={tenantId} freeShippingAch={freeShippingAch} flatAccessoryRate={flatAccessoryRate} hasPickupLocations={hasPickupLocations} paymentMethods={paymentMethods} checkoutMode={checkoutMode}>
      {/* Wraps `children` AND the layout's floating layers, which is the whole
          point — a page deep inside `children` declares its sticky commerce
          bar and the reviews floater, a sibling of `children`, reads it. */}
      <CommerceBarProvider>
        {children}
        <CartDrawer />
      </CommerceBarProvider>
    </CartProvider>
  )
}
